<template>

  <div>
    <div class="d-flex align-center" style="width: 100%;">

      <div style="width: inherit;">
        <v-text-field name="cron" readonly disabled :label="$t('core.cronfield.current_scheduling')" v-model="cron" :rules="cronRules(cron)" />

        <v-dialog v-model="dialog" max-width="900px">
          <template v-slot:activator="{ on }">
              <v-btn color="primary" dark style="width: inherit;" v-on="on">{{ $t('core.cronfield.configure') }}</v-btn>
          </template>
          <v-card>
              <v-card-title>
                  <span class="headline" v-text="$t('core.cronfield.configuring')" />
              </v-card-title>

              <v-card-text>
                <v-container>
                    <section>
                      <VueCronEditorBuefy
                        :key="langKey"
                        v-model="editingCron"
                        :preserveStateOnSwitchToAdvanced="true"
                        :visibleTabs="['minutes','hourly','daily', 'weekly', 'monthly','advanced']"
                        cronSyntax="quartz"
                        locale="en"
                        :custom-locales="{ en : customLocale }"
                      />
                    </section>
                    {{ $t('core.cronfield.cronExpression') }}: {{ editingCron }}
                </v-container>
              </v-card-text>

              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="closeDialog"
                  >
                    {{ $t('button.cancel') }}
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="saveDialog">
                    {{ $t('button.save') }}
                  </v-btn>
              </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <v-btn @click="loadCronExpression" icon color="green" > <v-icon>mdi-cached</v-icon> </v-btn>
    </div>
    <v-alert
      :type="alertType"
      v-model="alertShow"
      color="primary"
      class="mt-2"
    >{{ cronExpressionResult }}</v-alert>
  </div>

</template>

<script>
import { cronRules } from '../../utils/rules'
import cronExpression from '../../utils/CronExpression'
import VueCronEditorBuefy from 'vue-cron-editor-buefy'

export default {

  components: {
    VueCronEditorBuefy
  },

  props: {
    cron: String
  },

  model: {
    prop: 'cron',
    event: 'change'
  },

  computed: {
    $cron: {
      get () { return this.cron },
      set (value) { this.$emit('change', value) }
    },
    customLocale () {
      return {
        every: this.$t('core.cronfield.every'),
        mminutes: this.$t('core.cronfield.mminutes'),
        hoursOnMinute: this.$t('core.cronfield.hoursOnMinute'),
        daysAt: this.$t('core.cronfield.daysAt'),
        at: this.$t('core.cronfield.at'),
        onThe: this.$t('core.cronfield.onThe'),
        dayOfEvery: this.$t('core.cronfield.dayOfEvery'),
        monthsAt: this.$t('core.cronfield.monthsAt'),
        everyDay: this.$t('core.cronfield.everyDay'),
        mon: this.$t('core.cronfield.mon'),
        tue: this.$t('core.cronfield.tue'),
        wed: this.$t('core.cronfield.wed'),
        thu: this.$t('core.cronfield.thu'),
        fri: this.$t('core.cronfield.fri'),
        sat: this.$t('core.cronfield.sat'),
        sun: this.$t('core.cronfield.sun'),
        hasToBeBetween: this.$t('core.cronfield.hasToBeBetween'),
        and: this.$t('core.cronfield.and'),
        minutes: this.$t('core.cronfield.minutes'),
        hourly: this.$t('core.cronfield.hourly'),
        daily: this.$t('core.cronfield.daily'),
        weekly: this.$t('core.cronfield.weekly'),
        monthly: this.$t('core.cronfield.monthly'),
        advanced: this.$t('core.cronfield.advanced'),
        cronExpression: this.$t('core.cronfield.cronExpression')
      }
    }
  },

  data: () => ({
    editingCron: '',
    cronRules,
    dialog: false,
    alertShow: false,
    alertType: 'info',
    cronExpressionResult: '',
    langKey: false
  }),

  mounted () {
    this.$cron = this.$cron ?? ''
    this.editingCron = this.$cron
  },

  methods: {
    closeDialog () {
      this.dialog = false
      this.editingCron = this.$cron ?? ''
    },
    saveDialog () {
      this.dialog = false
      this.$cron = this.editingCron
    },
    async loadCronExpression () {
      if (this.cron) {
        this.alertShow = false
        const result = await cronExpression(this.cron)
        this.alertType = result?.data?.description?.includes('rro') ? 'info' : 'error'
        this.cronExpressionResult = result.data.description ? result.data.description : this.$t('warnings.incorrect_cron')
        this.alertShow = true
      }
    }
  },

  watch: {
    '$i18n.locale' () {
      this.langKey = !this.langKey // Trick to force the recompute of <VueCronEditorBuefy/>
    }
  }

}
</script>
